<script lang="ts">
  import { goto } from '$app/navigation';
  import { sendChatMessage } from '$lib/utils/chats';
  import Button from '../Button.svelte';
  import Modal from '../Modal.svelte';
  import SlideOver from '../SlideOver.svelte';
  import TextArea from '../TextArea.svelte';
  import SendIcon from '$icons/messages/SendIcon.svelte';

  export let showMessageModal = false;
  export let receiverId: number;

  let messageContent = '';

  const handleSendMessage = async () => {
    const conversationId = await sendChatMessage(Number(receiverId), messageContent);

    showMessageModal = false;
    if (conversationId) goto('/messages');
  };
</script>

<SlideOver title="Send a message" bind:slideOverOpen={showMessageModal} class="md:hidden">
  <TextArea bind:value={messageContent} limitEnforced={false} placeholder="Type your message ..." />
  <div class="mt-4 flex w-full items-center justify-end">
    <Button secondary size="md" disabled={!messageContent} on:click={handleSendMessage}>
      Send
      <SendIcon />
    </Button>
  </div>
</SlideOver>

<Modal title="Send a message" bind:modalOpen={showMessageModal} class="z-50 hidden md:block">
  <TextArea bind:value={messageContent} limitEnforced={false} placeholder="Type your message ..." />
  <div class="mt-4 flex w-full items-center justify-end">
    <Button secondary size="md" disabled={!messageContent} on:click={handleSendMessage}>
      Send
      <SendIcon />
    </Button>
  </div>
</Modal>
